/* ============================================================
   tio-fly.js - Copia LITERAL de diseno/previews/te-fly.js.
   Al final se agrega teFlySafe, que la doctrina MIGRATION 8.1 (F3)
   exige para el cableado: el vuelo es DECORACION y nunca puede
   impedir que la venta ocurra ni que el feedback sea honesto.
   El PNG llega por data-te-fly-img en el script tag.
   ============================================================ */

/* ============================================================
   Tio Elixir — FLY-TO-CART GLOBAL (regla universal)
   Un solo util para TODAS las páginas: Home (Quick View), Colección,
   Catálogo, PDP (CTA + sheet + relacionados) y cualquier drawer/modal.

   REGLA UNIVERSAL: toda acción que efectivamente agrega al carrito
   dispara (1) el mini-atomizador TE volando en arco al carrito del
   header, (2) bounce del carrito + contador subiendo AL ATERRIZAR,
   (3) check "Agregado" en el botón de origen (lo maneja cada botón).

   Uso:  window.teFlyToCart(srcEl, onLand)
     · srcEl  = el botón que disparó el add (siempre visible; si el
                origen está en un modal/drawer, es el botón DEL modal)
     · onLand = callback al aterrizar → ahí se incrementa el contador
                (el bounce del carrito lo dispara el propio contador)

   Destino: el botón de carrito del header expone [data-te-cart]
   (te-header.jsx). Fallback: ids conocidos por página.

   Valores = spec de la PDP (PDP.spec.md §FLY-TO-CART) — NO reinventar.
   Regla global documentada en FlyToCart.spec.md.
   En Liquid: mismo archivo como asset (assets/te-fly.js), el PNG fijo
   assets/fly-cart/decant-te-fly.png se sube como asset del tema.
   ============================================================ */
(() => {
  if (window.teFlyToCart) return; /* idempotente */

  /* Elemento FIJO que vuela (mismo decant TE para todos los productos) */
  const FLY_IMG = (document.currentScript && document.currentScript.dataset && document.currentScript.dataset.teFlyImg) || '../assets/fly-cart/decant-te-fly.png'; /* override para consumo fuera de previews/: <script src="te-fly.js" data-te-fly-img="{{ 'decant-te-fly.png' | asset_url }}"> (F5-assets, BugSweep jul-2026) */
  /* precarga + decode: listo en caché antes del primer clic */
  (function preloadFly() { const i = new Image(); i.src = FLY_IMG; if (i.decode) i.decode().catch(() => {}); })();

  /* estilos propios (z 1300: por encima de sheet 990, qv 1000 y overlays) */
  if (!document.getElementById('te-fly-style')) {
    const st = document.createElement('style');
    st.id = 'te-fly-style';
    st.textContent = [
      '.te-fly { position: fixed; z-index: 1300; pointer-events: none; will-change: transform, opacity; }',
      '.te-fly__img { width: 100%; height: auto; display: block; border-radius: 8px; filter: drop-shadow(0 10px 18px rgba(10,18,36,0.32)); }',
      '.te-fly .te-decant { width: 100%; }',
      '.te-fly .te-decant::after { display: none; }',
    ].join('\n');
    document.head.appendChild(st);
  }

  /* destino: carrito del header ([data-te-cart]) o ids conocidos */
  const findCart = () =>
    document.querySelector('[data-te-cart]') ||
    document.getElementById('pdpCart') ||
    document.getElementById('homeCart') ||
    document.getElementById('chCartBtn') ||
    document.getElementById('catCartBtn');

  window.teFlyToCart = function teFlyToCart(srcEl, onLand) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { if (onLand) onLand(); return; }
    const cart = findCart();
    if (!cart || !srcEl || !srcEl.getBoundingClientRect) { if (onLand) onLand(); return; }
    const s = srcEl.getBoundingClientRect();
    const c = cart.getBoundingClientRect();
    const w = 64;
    const startX = s.left + s.width / 2 - w / 2;
    const startY = s.top + s.height / 2 - w / 2;
    const endX = c.left + c.width / 2 - w / 2;
    const endY = c.top + c.height / 2 - w / 2;
    const dx = endX - startX, dy = endY - startY;
    /* pico del arco: por encima del punto más alto, acotado a ≥10px del borde */
    let peakY = Math.min(0, dy) - 60;
    if (startY + peakY < 10) peakY = 10 - startY;
    const midX = dx * 0.5;
    const dist = Math.hypot(dx, dy);
    const duration = Math.max(780, Math.min(1040, 640 + dist * 0.45));
    const DECANT = '<div class="te-decant"><div class="te-decant__cap"></div><div class="te-decant__neck"></div><div class="te-decant__body"><div class="te-decant__liquid"></div><div class="te-decant__label"></div></div></div>';
    const fly = document.createElement('div');
    fly.className = 'te-fly';
    fly.style.left = startX + 'px'; fly.style.top = startY + 'px'; fly.style.width = w + 'px';
    fly.style.opacity = '0'; /* no se muestra hasta que la imagen esté lista (timing consistente) */
    fly.innerHTML = '<img class="te-fly__img" alt="" src="' + FLY_IMG + '">';
    const im = fly.querySelector('img');
    im.onerror = () => { fly.innerHTML = DECANT; }; /* fallback: decant CSS, nunca imagen rota */
    document.body.appendChild(fly);
    let started = false;
    const run = () => {
      if (started) return; started = true;
      fly.style.opacity = '';
      const a = fly.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + midX + 'px, ' + peakY + 'px) scale(0.82) rotate(-8deg)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.24) rotate(6deg)', opacity: 0.3, offset: 1 },
      ], { duration: duration, easing: 'cubic-bezier(0.42, 0, 0.22, 1)', fill: 'forwards' });
      let done = false;
      const finish = () => { if (done) return; done = true; fly.remove(); if (onLand) onLand(); };
      a.onfinish = finish;
      setTimeout(finish, duration + 140); /* respaldo: garantiza limpieza + conteo */
    };
    /* arranca cuando la imagen está decodificada (timing idéntico 1er/enésimo intento) */
    if (im.complete && im.naturalWidth) { if (im.decode) im.decode().then(run).catch(run); else run(); }
    else { im.addEventListener('load', run, { once: true }); im.addEventListener('error', run, { once: true }); }
    setTimeout(run, 80);
  };
})();


/* ============================================================
   AGREGADO POR EL CABLEADO (MIGRATION 8.1, cadena F3)
   teFlySafe: si te-fly no cargo o falla, onLand se ejecuta IGUAL
   y de inmediato. Asi el contador se actualiza y el feedback no
   miente aunque la animacion no exista.
   ============================================================ */
(function () {
  if (window.teFlySafe) return;
  window.teFlySafe = function (srcEl, onLand) {
    try {
      if (typeof window.teFlyToCart === 'function') { window.teFlyToCart(srcEl, onLand); return; }
    } catch (e) { /* la decoracion nunca rompe la venta */ }
    if (onLand) onLand();
  };
})();
